module.exports = __webpack_public_path__ + "img/fi-toasts-200x132.6ab55676.jpg";